var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgInteractiveItem = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 200,
  height: 212,
  viewBox: "0 0 200 212",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M196 0C198.209 0 200 1.79086 200 4V129C200 131.209 198.209 133 196 133H4C1.79086 133 0 131.209 0 129V4C0 1.79086 1.79086 0 4 0H196Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156 144C158.209 144 160 145.791 160 148V160C160 162.209 158.209 164 156 164H4C1.79086 164 0 162.209 0 160V148C0 145.791 1.79086 144 4 144H156Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196 168C198.209 168 200 169.791 200 172V184C200 186.209 198.209 188 196 188H4C1.79086 188 0 186.209 0 184V172C0 169.791 1.79086 168 4 168H196Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68 192C70.2091 192 72 193.791 72 196V208C72 210.209 70.2091 212 68 212H4C1.79086 212 0 210.209 0 208V196C0 193.791 1.79086 192 4 192H68Z",
  fill: "black"
}))));
export default SvgImgInteractiveItem;